import { Icon } from '@iconify/react';

function CustomerCard(props) {
  const { profile, handleChangePhoto } = props;
  const isHo = profile.data.accountType === 'HO';

  const rowsLeft = [
    {
      icon: 'solar:buildings-2-bold',
      label: isHo ? 'Nama Perusahaan' : 'Nama',
      value: isHo ? profile.data.username : profile.data.nama
    },
    ...(isHo
      ? [
          {
            icon: 'solar:map-point-bold',
            label: 'Alamat',
            value: profile.data.Customer.address
          }
        ]
      : []),
    {
      icon: 'solar:phone-bold',
      label: 'Phone',
      value: isHo ? profile.data.Customer.phone_number : profile.data.nohp
    }
  ];

  const rowsRight = [
    {
      icon: 'solar:letter-bold',
      label: 'Email',
      value: profile.data.email
    },
    ...(isHo
      ? [
          {
            icon: 'solar:document-text-bold',
            label: 'NPWP',
            value: profile.data.Customer.npwp
          },
          {
            icon: 'solar:calendar-bold',
            label: 'Bergabung Sejak',
            value: new Date(profile.data.Customer.created_at).toLocaleString(
              'id-ID',
              {
                month: 'long',
                year: 'numeric',
                day: 'numeric'
              }
            )
          }
        ]
      : [])
  ];

  const renderRow = (row, key) => (
    <div className='profile-info__row' key={key}>
      <span className='profile-info__icon' aria-hidden>
        <Icon icon={row.icon} width={18} height={18} />
      </span>
      <div className='profile-info__copy'>
        <p className='profile-info__label'>{row.label}</p>
        <p className='profile-info__value'>{row.value || '-'}</p>
      </div>
    </div>
  );

  return (
    <div className='profile-info'>
      <div className='profile-info__col'>
        {rowsLeft.map((row, idx) => renderRow(row, `left-${idx}`))}

        {isHo && (
          <div className='profile-info__row is-upload'>
            <span className='profile-info__icon' aria-hidden>
              <Icon icon='solar:gallery-bold' width={18} height={18} />
            </span>
            <div className='profile-info__copy'>
              <p className='profile-info__label'>Logo Perusahaan</p>
              <input
                className='sb-form__control sb-form__control--file'
                type='file'
                id='photo'
                name='photo'
                accept='.jpg,.jpeg,.png'
                onChange={e => handleChangePhoto(e.target.files[0])}
              />
            </div>
          </div>
        )}
      </div>

      <div className='profile-info__col'>
        {rowsRight.map((row, idx) => renderRow(row, `right-${idx}`))}
      </div>
    </div>
  );
}

export default CustomerCard;
